(() => {
  const GAP = 14;
  const MARGIN = 10;
  let frame = 0;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), Math.max(min, max));

  function viewportRect() {
    const vv = window.visualViewport;
    if (vv) {
      return {
        left: vv.offsetLeft,
        top: vv.offsetTop,
        right: vv.offsetLeft + vv.width,
        bottom: vv.offsetTop + vv.height
      };
    }
    return { left: 0, top: 0, right: window.innerWidth, bottom: window.innerHeight };
  }

  function closeBubble(bubble) {
    if (!bubble) return;
    bubble.classList.remove('is-open');
    bubble.querySelector('[data-wn-bubble-trigger]')?.setAttribute('aria-expanded', 'false');
    const panel = bubble.querySelector('[data-wn-bubble-panel]');
    if (panel) panel.hidden = true;
  }

  function overflowPenalty(candidate, bounds, width, height) {
    return Math.max(0, bounds.left - candidate.left)
      + Math.max(0, candidate.left + width - bounds.right)
      + Math.max(0, bounds.top - candidate.top)
      + Math.max(0, candidate.top + height - bounds.bottom);
  }

  function positionBubble(bubble) {
    if (!bubble?.classList.contains('is-open')) return;
    const trigger = bubble.querySelector('[data-wn-bubble-trigger]');
    const panel = bubble.querySelector('[data-wn-bubble-panel]');
    const stage = bubble.closest('.wn-ux-gallery__stage');
    if (!trigger || !panel || panel.hidden || !stage) return;

    const view = viewportRect();
    const triggerRect = trigger.getBoundingClientRect();
    if (triggerRect.right < view.left || triggerRect.left > view.right || triggerRect.bottom < view.top || triggerRect.top > view.bottom) {
      closeBubble(bubble);
      return;
    }

    const panelRect = panel.getBoundingClientRect();
    const width = panelRect.width;
    const height = panelRect.height;
    const stageRect = stage.getBoundingClientRect();

    const viewportBounds = {
      left: view.left + MARGIN,
      top: view.top + MARGIN,
      right: view.right - MARGIN,
      bottom: view.bottom - MARGIN
    };
    const imageBounds = {
      left: Math.max(viewportBounds.left, stageRect.left + MARGIN),
      top: Math.max(viewportBounds.top, stageRect.top + MARGIN),
      right: Math.min(viewportBounds.right, stageRect.right - MARGIN),
      bottom: Math.min(viewportBounds.bottom, stageRect.bottom - MARGIN)
    };
    const imageCanContainPanel = (imageBounds.right - imageBounds.left) >= width && (imageBounds.bottom - imageBounds.top) >= height;
    const bounds = imageCanContainPanel ? imageBounds : viewportBounds;

    const anchorX = triggerRect.left + (triggerRect.width / 2);
    const anchorY = triggerRect.top + (triggerRect.height / 2);
    const candidates = [
      { placement: 'right', left: triggerRect.right + GAP, top: anchorY - (height / 2) },
      { placement: 'left', left: triggerRect.left - GAP - width, top: anchorY - (height / 2) },
      { placement: 'bottom', left: anchorX - (width / 2), top: triggerRect.bottom + GAP },
      { placement: 'top', left: anchorX - (width / 2), top: triggerRect.top - GAP - height }
    ];

    let best = candidates[0];
    let bestScore = Infinity;
    candidates.forEach((candidate, index) => {
      const score = (overflowPenalty(candidate, bounds, width, height) * 100) + index;
      if (score < bestScore) {
        best = candidate;
        bestScore = score;
      }
    });

    const left = clamp(best.left, bounds.left, bounds.right - width);
    const top = clamp(best.top, bounds.top, bounds.bottom - height);
    const bubbleRect = bubble.getBoundingClientRect();
    panel.style.setProperty('--wn-bubble-panel-left', `${left - bubbleRect.left}px`);
    panel.style.setProperty('--wn-bubble-panel-top', `${top - bubbleRect.top}px`);
    panel.dataset.placement = best.placement;

    if (best.placement === 'right' || best.placement === 'left') {
      panel.style.setProperty('--wn-bubble-arrow-y', `${clamp(anchorY - top, 18, height - 18)}px`);
      panel.style.removeProperty('--wn-bubble-arrow-x');
    } else {
      panel.style.setProperty('--wn-bubble-arrow-x', `${clamp(anchorX - left, 18, width - 18)}px`);
      panel.style.removeProperty('--wn-bubble-arrow-y');
    }
  }

  function positionOpenBubbles() {
    document.querySelectorAll('[data-wn-bubble].is-open').forEach(positionBubble);
  }

  function schedulePositioning() {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      positionOpenBubbles();
    });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-wn-bubble-trigger]');
    if (!trigger) return;
    const bubble = trigger.closest('[data-wn-bubble]');
    window.requestAnimationFrame(() => positionBubble(bubble));
  }, true);

  window.addEventListener('resize', schedulePositioning, { passive: true });
  window.addEventListener('scroll', schedulePositioning, { passive: true });
  window.visualViewport?.addEventListener('resize', schedulePositioning, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedulePositioning, { passive: true });
  document.addEventListener('shopify:section:load', schedulePositioning);
})();
